import axios from 'axios';

// CPAYMENT-1480: cap request time so the page surfaces an error instead of hanging
// when the request body upload stalls on bad client connections (observed 60s nginx 408).
export const REQUEST_TIMEOUT_MS = 20000;

/**
 * The page's CSRF token, minted once and shared.
 *
 * It used to live inside `api.ts`, reachable only by the axios interceptors there. The behaviour
 * snapshot leaves on `page.hidden` through a raw `fetch` with `keepalive`, which no interceptor
 * touches, so it needs the token too — and a second cache would mean a second token and a second
 * round trip on the way out, exactly where there is no time for one.
 */
let csrfTokenPromise: Promise<string> | null = null;

const fetchCsrfToken = async (): Promise<string> => {
  const response = await axios.get('/api/csrf-token', { timeout: REQUEST_TIMEOUT_MS });
  return response.data.csrfToken;
};

export const ensureCsrfToken = (): Promise<string> => {
  if (!csrfTokenPromise) {
    csrfTokenPromise = fetchCsrfToken().catch((error) => {
      csrfTokenPromise = null;
      throw error;
    });
  }
  return csrfTokenPromise;
};

/** Drops the cached token so the next caller mints a fresh one. */
export const resetCsrfToken = (): void => {
  csrfTokenPromise = null;
};

export const _resetCsrfForTests = (): void => {
  csrfTokenPromise = null;
};
